import React from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as Statistics } from "Assets/icons/statistics.svg";
import { ReactComponent as OffersAnnouncement } from "Assets/icons/offersAnnouncement.svg";
import { ReactComponent as Tradeboard } from "Assets/icons/tradeboard.svg";
import { ReactComponent as DerivativeMarketIcon } from "Assets/icons/derivativeMarket.svg";
const DerivativeMarket = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100 align-items-center">
                <div className="col-9">
                    <div className="row">
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/DerivativeMarket/TradeBoard" className="tradesFeeItems py-2 px-4 w-100">
                                <Tradeboard
                                    className="max-width-100 mx-2 d-inline-block"
                                />

                                {t('derivatives_market_board')}
                            </a>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/DerivativeMarket/Announcements" className="tradesFeeItems py-2 px-4 w-100">
                                <OffersAnnouncement
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('derivatives_market_notices')}
                            </a>
                        </div>
                    </div>
                    <div className="row">

                        <div className="col-5 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Market/DerivativeMarket/Statistics" className="tradesFeeItems py-2 px-4 w-100">
                                <Statistics
                                    className="max-width-100 mx-2 d-inline-block"
                                />
                                {t('derivatives_market_stats')}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-3 d-flex justify-content-center align-items-center">
                    <DerivativeMarketIcon
                        width={"100%"}
                        height={"100%"}
                        className="w-100 mx-2 d-block text-blue p-5"
                    />
                </div>

            </div>

        </div>
    );
};

export default DerivativeMarket;
